import { useState, useEffect } from 'react';
import styles from './NewsBlock.module.scss';
import { useSelector } from 'react-redux';
import defaultImage from '../../../images/object_mask_profile.svg';
import Arrow from '../../../images/arrow-blue.svg';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { formatDate } from '../../../functions/formatDate';
import SkeletonNewsBlock from '../../universal_components/Skeletots/SkeletonNewsBlock';

import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

const NewsBlock = () => {
  const [news, setNews] = useState([]);
  const [itemCategoty, setItemCategory] = useState('events');
  const newsList = useSelector((state) => state.news.events);

  useEffect(() => {
    if (!newsList) return;
    newsList.map((item) => {
      if (item.images.length === 0) {
        item.images.push({ image: defaultImage, cropped_image: defaultImage });
      }
    });
    setNews(newsList);
  }, [newsList]);

  const CustomPrevArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
        }}
        onClick={onClick}>
        <img src={Arrow} alt="Предыдущие новости" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
          rotate: '180deg',
        }}
        onClick={onClick}>
        <img src={Arrow} alt="Следующие новости" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  // отмена клика через PreventDefault
  const handleLinkMouseDown = (e) => {
    // Запоминаем начальную позицию и сам элемент
    const startX = e.clientX;
    const linkElement = e.currentTarget; // Сохраняем ссылку на DOM-элемент

    const handleMouseMove = (e) => {
      // Если движение мыши > 5px — это свайп, отменяем клик
      if (Math.abs(e.clientX - startX) > 5) {
        e.preventDefault();
        if (linkElement) {
          // Проверяем, что элемент существует
          linkElement.style.pointerEvents = 'none';
        }
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      // Восстанавливаем события через 100 мс
      setTimeout(() => {
        if (linkElement) {
          linkElement.style.pointerEvents = 'auto';
        }
      }, 100);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp, { once: true });
  };

  const settings = {
    dots: false,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: false,
    draggable: true,
    lazyLoad: true,
    swipeToSlide: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className={styles.newsBlock} id="newsBlock">
      <div className={styles.head}>
        <h2 className={classnames(styles.title, { [styles.mobile]: isMobile })}>Новости</h2>
        <Link to="/news" className={classnames(styles.link, { [styles.mobile]: isMobile })}>
          <span>В архив новостей</span>
        </Link>
      </div>

      {!news.length ? (
        <Slider {...settings}>
          {Array.from({ length: 10 }).map((_, index) => (
            <SkeletonNewsBlock key={index} width={240} height={243} className={styles.skeleton} />
          ))}
        </Slider>
      ) : (
        <Slider {...settings}>
          {news.map((item) => {
            if (item.category === 'media') {
              setItemCategory('media');
            }
            return (
              <Link
                to={`/news/${itemCategoty}/${item.id}`}
                key={item.id}
                className={styles.item}
                onClick={(e) => {
                  // Дополнительная защита (если pointerEvents не сработал)
                  if (e.currentTarget.style.pointerEvents === 'none') {
                    e.preventDefault();
                  }
                }}
                onMouseDown={handleLinkMouseDown}>
                <div className={styles.newsImage}>
                  {/* <img src={item.images[0].cropped_image} alt="" /> */}
                  <p className={styles.newsTitle}>{item.title}</p>
                </div>
                <p className={styles.newsDate}>{formatDate(item.date_to_show)}</p>
                {/* <p className={styles.newsTitle}>{item.title}</p> */}
              </Link>
            );
          })}
        </Slider>
      )}
    </section>
  );
};

export default NewsBlock;
